import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import taxbill, { taxbillSaga } from './taxbill';
import taxbills, { taxbillsSaga } from './taxbills';
import bondsDepts, { bondsDeptsSaga } from './bonds-depts';

import collectsBuys, { collectsBuysSaga } from './collects-buys';

const taxbillModule = combineReducers({
  taxbills,
  taxbill,
  bondsDepts,
  collectsBuys,
});

export function* taxbillModuleSaga() {
  yield all([
    taxbillsSaga(),
    taxbillSaga(),
    bondsDeptsSaga(),
    collectsBuysSaga(),
  ]);
}

export default taxbillModule;
